package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.StudioService
import br.com.heyagenda.domain.repository.ServiceRepository
import kotlinx.coroutines.flow.Flow

class GetServicesUseCase(
    private val repository: ServiceRepository
) {
    operator fun invoke(): Flow<List<StudioService>> {
        return repository.getServices()
    }
}
